module.exports = __webpack_public_path__ + "static/media/bag4.a32ea074.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Projects/MU/assets/bag4.jpg
// module id = 188
// module chunks = 0